<template>
  <!--<transition name="fade">-->
    <div v-if="show" style="margin-top:12px;">
      <div class="col-md-3 col-sm-3 col-xs-3">

      </div>
      <div class="col-md-18 col-sm-18 col-xs-18" style="padding-left:10px;">

          <p>
            <font-awesome-icon icon="envelope" class="red icon ddv" style="color: #c51a1b;" /> <a>{{dealer.email1}}</a>
          </p>
          <p>
            <font-awesome-icon icon="phone" class="red icon ddv" style="color: #c51a1b;" />  <a href="">{{dealer.telefon1}}</a>
          </p>
          <p v-if="dealer.homepage">
            <font-awesome-icon icon="globe" class="red icon ddv" style="color: #c51a1b;" /> <a v-bind:href="'https://' + dealer.homepage" target="_blank">{{dealer.homepage}}</a>
          </p>
          <p v-if="dealer.fahrzeuganzahl>0">
            <font-awesome-icon icon="arrow-right" class="red icon ddv" style="color: #c51a1b;" /> <a v-bind:href="'/index.php?id=228&amp;/#/d/' + dealer.uid" target="_blank">Fahrzeugangebot des Händlers auf rewaco24</a>
          </p>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3">

      </div>

  </div>
  <!--</transition>-->
</template>

<script>

export default {
  name: 'DealerInfo',
  props: ['dealer','show','index'],
  data: function() {
    return {
      body: "",
      disabled: true,
      imageUrl: null,
    }
  },
  components: {

  },
  created: function() {
  },
  beforeDestroy () {
  },
  methods: {

    inViewport: function (e) {

    }
  }
}
</script>

<style scoped>

.ddv{
  min-width: 30px;
}
.fade-enter-active{
  transition: opacity .0s;
}

.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.raute p {
    width: 100%;
    text-align: center;
    line-height: 32px;
    color: white;
}

.more{
  width: 100%;
  text-align: center;
}
.dealeritem{
  border-bottom: 1px solid rgba(34,36,38,.15);
  padding-bottom: 20px;
  margin-bottom: 20px;
}
</style>
